var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_shamrock-core_com-a09249"), __webpack_require__.e("vendors-node_modules_shamrock-core_common_analytics_firebase-analytics_js-node_modules_react--2453d1"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_features_clientSearch_ClientSearch_tsx"), __webpack_require__.e("src_App_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/App */ "./src/App.tsx")))));
	},
	"./ClientSearch": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_reduxjs_toolkit_dist_redux-toolkit_esm_js-node_modules_shamrock-core_com-a09249"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_features_clientSearch_ClientSearch_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/features/clientSearch/ClientSearch */ "./src/features/clientSearch/ClientSearch.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});